// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"8b0cb891","656":"bb3cf216","802":"a4183b87","877":"bb3cf216"}[chunkId] + ".chunk.css";
};